import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import useInvoke from "../../Tools/Invoker";
import CheckToken from "../../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import GetAddresses from "../Tools/OilersGetAddresses";
import UpdateOiler from "../Tools/OilerUpdateOiler";
import { type } from "@testing-library/user-event/dist/type";
import DynamicGrid from "../../Tools/DynamicGrid";

const OilerDetails = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();
    const { id } = useParams();
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    const [oiler, setOiler] = useState({});
    const [siteLocations, setSiteLocations] = useState([]);
    const [configurations, setConfigurations] = useState([]);

    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    const [selectedSite, setSelectedSite] = useState("");

    const response89 = useInvoke("WebApps", "89", { "@oilerID": id });
    const response92 = useInvoke("WebApps", "92", { "@oilerID": id });

    useEffect(() => {
        if (response89.data.payload != undefined) {
            const myOiler = JSON.parse(response89.data.payload).data;
            const obj = {
                OilerID: myOiler[0][0],
                JobNum: myOiler[0][1],
                SiteAddressID: myOiler[0][2],
                NumTestPoints: myOiler[0][3],
                InFeedSensorDistance: myOiler[0][4],
                CustomerID: myOiler[0][5],
                CustomerName: myOiler[0][6],
                CustomerAddress: myOiler[0][7],
                CityStateZip: myOiler[0][8],
                SiteName: myOiler[0][9],
                SiteAddressName: myOiler[0][10],
                SiteCityStateZip: myOiler[0][11],
                DateCreated: myOiler[0][12],
                CreatedByID: myOiler[0][13],
                CreatedByName: myOiler[0][14],
                Notes: myOiler[0][15]
            };
            setOiler(obj);
            setSelectedSite(obj.SiteAddressID); // Set initial selected site
        }

        if (response92.data.payload != undefined) {
            const myConfigurations = JSON.parse(response92.data.payload).data;

            let breakpoint = "";

            let configList = [];

            myConfigurations.forEach((entry, index) => {

                let numBlanksString = "";

                if (entry[8] == 1) {
                    numBlanksString = "Single";
                } else if (entry[8] == 2) {
                    numBlanksString = "Double";
                } else {
                    numBlanksString = "Unknown";
                }

                let obj = {
                    ConfigID: entry[0],
                    OilID: entry[1],
                    OilName: entry[2],
                    CustomerBlankNum: entry[3],
                    Length: entry[4],
                    Width: entry[5],
                    Speed: entry[6],
                    Coverage: entry[7],
                    NumberOfBlanks: entry[8],
                    OilTemp: entry[9],
                    AsShipped: entry[10],
                    OilerID: entry[11],
                    CreatedDate: entry[12],
                    numTests: entry[13],
                    numBlanksString: numBlanksString
                }

                configList.push(obj);
            });

            setConfigurations(configList);
        }

    }, [response89.data.payload, response92.data.payload]);

    useEffect(() => {
        if (oiler["CustomerID"] != undefined) {
            GetAddresses(oiler["CustomerID"])
                .then(response => {
                    const mySiteLocations = JSON.parse(response.payload).data;

                    let siteList = [];

                    mySiteLocations.forEach((entry, index) => {

                        let a_name = "";
                        entry[1] == "" ? a_name = "[No Name]" : a_name = entry[1];

                        let l1 = entry[2] == "[No Address]" ? "" : entry[2];
                        let l2 = entry[3] == "" ? "" : entry[3];
                        let city = entry[4] == "" ? "[No City]" : entry[4];
                        let state = entry[5] == "" ? "[No State]" : entry[5];
                        let zip = entry[6] == "" ? "[No Zip]" : entry[6];

                        let obj = {
                            AdressID: entry[0],
                            AdressName: a_name,
                            Line1: l1,
                            Line2: l2,
                            City: city,
                            State: state,
                            Zip: zip,
                            siteString: `${a_name} ${l1} ${l2}, ${city}, ${state} ${zip}`
                        };

                        siteList.push(obj);
                    });
                    setSiteLocations(siteList);
                })
                .catch(error => {
                    console.error("Failed to fetch addresses:", error);
                    toast.error("Failed to fetch addresses");
                });
        }
    }, [oiler]);

    useEffect(() => {

        let rowsList = [];

        configurations.forEach((entry, index) => {

            let row = [

                { type: "text", content: { text: `${entry.AsShipped == "True" ? "✓" : " "}` } },
                { type: "text", content: { text: `${entry.numBlanksString}` } },
                { type: "text", content: { text: `${entry.Coverage}` } },
                { type: "text", content: { text: `${entry.numTests}` } },
                { type: "text", content: { text: `${entry.CustomerBlankNum}` } },
                { type: "text", content: { text: `${entry.Length}` } },
                { type: "text", content: { text: `${entry.Width}` } },
                { type: "text", content: { text: `${entry.Speed}` } },
                { type: "text", content: { text: `${entry.OilName}` } },
                { type: "text", content: { text: `${entry.OilTemp}` } },
                { type: "text", content: { text: `${entry.CreatedDate}` } },
                { type: "text", content: { text: `${entry.ConfigID}` } },
                { type: "link", content: { text: `View`, link: `/Oilers/Configuration/${entry.ConfigID}` } }
            ];
            rowsList.push(row);
        });

        setColumns(["As Shipped", "# Blanks", "Coverage Target (mg/sqft)", "# Tests", "Cust. Blank #", "Speed (fpm)", "Length (mm)", "Width (mm)", "Oil Name", "Oil Temp (°C)", "Created Date", "ID", "Action"]);
        setRows(rowsList);

    }, [configurations]);

    const handleSiteSelection = (e) => {
        setSelectedSite(e.target.value);

    };

    const handleUpdateOiler = () => {

        UpdateOiler(
            oiler.OilerID,
            oiler.JobNum,
            oiler.NumTestPoints,
            oiler.InFeedSensorDistance,
            selectedSite,
            user.id,
            document.getElementById("notes").value
        )
            .then(response => {
                if (response.success) {
                    toast.success("Oiler Updated");
                }
                else {
                    toast.error("Failed to update Oiler");
                }
            })
            .catch(error => {
                console.error("Failed to update Oiler:", error);
                toast.error("Failed to update Oiler");
            });

    };

    document.title = `Oiler ${oiler.JobNum} - ${oiler.CustomerID}`;
    return (
        <div className="oilerDetails">

            {user.email &&
                <div className="container body-content" style={{ marginTop: "25px" }}>

                    <div style={{ display: "flex", flexDirection: "row", margin: "0px", justifyContent: "space-between" }}>

                        <Link to="/Oilers" className="btn btn-default" style={{ width: "auto" }}>Back</Link>
                        {/* <Link to={`/Oilers/Details/Print/${id}`} className="btn btn-secondary" style={{ marginRight: "0px", width: "auto" }}>Print</Link> */}

                    </div>

                    <h2>Oiler Details: {`#${oiler.OilerID} - ${oiler.JobNum} - ${oiler.CustomerID}`}</h2>

                    {oiler.OilerID &&
                        <>
                            <div className="card mb-3">
                                <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>Oiler Details</div>
                                <div className="card-body text-primary d-flex flex-column">
                                    <div className="d-flex flex-row">

                                        <table className="table table-bordered mx-2" style={{ width: "50%" }}>
                                            <tbody>
                                                <tr>
                                                    <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Job Number</th>
                                                    <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.JobNum}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>JB Customer ID</th>
                                                    <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.CustomerID}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Customer Name</th>
                                                    <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.CustomerName}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Customer Address</th>
                                                    <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.CustomerAddress}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Customer City / State / Zip</th>
                                                    <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.CityStateZip}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <table className="table table-bordered mx-2" style={{ width: "50%" }}>
                                            <tbody>
                                                <tr>
                                                    <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Oiler ID</th>
                                                    <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.OilerID}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Date Created</th>
                                                    <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.DateCreated}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Created By</th>
                                                    <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.CreatedByName}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}># Test Points</th>
                                                    <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.NumTestPoints}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Infeed Sensor Distance <span className="text-secondary">(in)</span></th>
                                                    <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.InFeedSensorDistance}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                    <div className="form-group d-flex flex-row my-2 w-100">
                                        <div className="form-group flex-column w-100 mx-2">
                                            <label htmlFor="siteLocation" title="Addresses stored in JobBOSS for customer above." style={{ color: "var(--bs-dark)" }}>Site Location</label>
                                            <select className="form-control" style={{ width: "100%", maxWidth: "100%" }} id="siteLocation" name="siteLocation" value={selectedSite} onChange={handleSiteSelection}>
                                                {siteLocations.map((site, index) => (
                                                    <option key={index} value={site.AdressID}>{site.siteString}</option>
                                                ))}
                                            </select>
                                        </div>

                                    </div>

                                    <div className="form-group d-flex flex-row my-2 w-100">

                                        <div className="form-group flex-column w-100 mx-2">
                                            <label htmlFor="notes" style={{ color: "var(--bs-dark)" }}>Notes</label>
                                            <textarea className="form-control" id="notes" name="notes" rows="3" placeholder="Notes" style={{ width: "100%", maxWidth: "100%" }} defaultValue={oiler["Notes"]} />
                                        </div>
                                    </div>

                                    <hr />
                                    <div className="d-flex flex-row justify-content-end">
                                        <button className="btn btn-success mx-2" onClick={handleUpdateOiler}>Save Changes</button>
                                    </div>
                                </div>
                            </div>

                            <div className="card mb-3">
                                <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>Configurations</div>
                                <div className="card-body" style={{}}>

                                    {columns && rows && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} defaultsortindex={0} descending={true} />}

                                    <Link to={`/Oilers/Details/${oiler["OilerID"]}/NewConfiguration`} className="btn btn-success" style={{ width: "100%", marginTop: "8px" }}>
                                        New Configuration
                                    </Link>

                                </div>
                            </div>

                        </>
                    }

                    <div style={{ display: "flex", flexDirection: "row", marginTop: "0px", justifyContent: "space-between" }}>

                        <Link to="/Oilers" className="btn btn-default" style={{ width: "auto" }}>Back</Link>
                        {/* <Link to={`/Oilers/Details/Print/${id}`} className="btn btn-secondary" style={{ marginRight: "0px", width: "auto" }}>Print</Link> */}

                    </div>

                </div>
            }
        </div >
    );
}

export default OilerDetails;